export function fixProductTaxons (product) {
  // expected
  // {
  //   "main": "taxon1",
  //   "others": [
  //     "taxon2"
  //   ],
  //   "othersWithSort": [
  //     {
  //       "taxon": "taxon3",
  //       "pos": 4
  //     }
  //   ]
  // }
  product.taxonsSort = {}
  if (!(product.taxons instanceof Array)) {
    product.taxons = Object.values(product.taxons)
      .reduce((p, c) => c instanceof Array ? p.concat(c) : p.concat([c]), [])
      .map(v => {
        if (typeof v === 'object') {
          product.taxonsSort[v.taxon] = v.pos
          v = v.taxon
        }
        return v
      })
  }
  return product
}

export function fixTaxon (taxon, parentCode = null) {
	return {
		...taxon,
		parentCode,
		image: (taxon.images && taxon.images.length > 0)
				? taxon.images[0].path
				: "",
		children: taxon.children.map(childTaxon => {
			return fixTaxon(childTaxon, taxon.code)
		})
	}
}